function buildScriptTag(schemaObj) {
  const scriptTag = document.createElement('script');
  scriptTag.setAttribute('type', 'application/ld+json');
  scriptTag.innerText = JSON.stringify(schemaObj);
  return scriptTag;
}

function getSchemaObject(product, pricing) {
  const schemaObj = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    brand: {
      '@type': 'Brand',
    },
    offers: {
      '@type': 'Offer',
      url: document.location.href,
      priceCurrency: 'USD',
    },
  };

  if (product.modelName) {
    schemaObj.name = product.modelName;
  }

  if (Array.isArray(product.images) && product.images.length) {
    schemaObj.image = product.images.map((img) => img.url);
  }

  if (product.longDescription) {
    schemaObj.description = product.longDescription;
  }

  if (product.sku) {
    schemaObj.sku = product.sku;
  }

  if (product.brand.name) {
    schemaObj.brand.name = product.brand.name;
  }

  if (product.productDetails.size) {
    schemaObj.size = product.productDetails.size;
  }

  if (product.productDetails.price[pricing.pricingGroup]) {
    schemaObj.offers.price = product.productDetails.price[pricing.pricingGroup];
  }

  return schemaObj;
}

function initializeSchema(product, pricing) {
  const { body, addEventListener } = document;
  if (body && product && pricing) {
    addEventListener('DOMContentLoaded', () => {
      const schemaObj = getSchemaObject(product, pricing);
      const scriptTag = buildScriptTag(schemaObj);
      body.appendChild(scriptTag);
    });
  }
}

export {
  initializeSchema,
};
